<template>
    <div class="bg-gray-200">

    <Header />

    <!--Container-->
		<div class="container max-w-6xl px-4 mx-auto -mt-32 md:px-0">
			
			<div class="mx-0 sm:mx-6">

      <div v-for="event in events" :key="event.id" class="w-full pb-12 text-xl leading-normal text-gray-800 bg-gray-200 rounded-t md:text-2xl">
        <div class="flex flex-wrap overflow-hidden bg-white border-4 rounded shadow-lg border-live-orange">
          

            <div class="w-full rounded-t lg:w-2/3">	
              <img :src=event.artistimage class="object-cover w-full h-full shadow">
            </div>

            <div class="flex flex-col flex-grow flex-shrink w-full lg:w-1/3">
            <div class="flex-1 overflow-hidden bg-white rounded-t rounded-b-none shadow-lg">
                
                <div class="flex items-start justify-between w-full pt-8">
                    <div class="w-full px-6 text-xl font-bold text-gray-900">{{ event.artist }}</div>
                    <div class="flex items-center content-center justify-end w-full px-4">
                        
                        <a v-if="event.artist" class="inline-block h-10 px-2 text-center text-gray-800 no-underline hover:text-live-orange hover:text-underline md:h-auto md:px-2 avatar" data-tippy-content="website" target="_blank" href="<?= $website ?>">
                            <svg class="h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 13v10h-6v-6h-6v6h-6v-10h-3l12-12 12 12h-3zm-1-5.907v-5.093h-3v2.093l3 3z"/></svg>	
                        </a>
                        
                        <a v-if="event.artist" class="inline-block h-10 px-2 text-center text-gray-800 no-underline hover:text-live-orange hover:text-underline md:h-auto md:px-2 avatar" data-tippy-content="@instagram" target="_blank" href="<?= $instagram ?>">
                            <svg class="h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>	
                        </a>
                        
                        <a v-if="event.artist" class="inline-block h-10 px-2 text-center text-gray-800 no-underline hover:text-live-orange hover:text-underline md:h-auto md:px-2 avatar" data-tippy-content="@twitter" target="_blank" href="<?= $twitter ?>">
                            <svg class="h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M30.063 7.313c-.813 1.125-1.75 2.125-2.875 2.938v.75c0 1.563-.188 3.125-.688 4.625a15.088 15.088 0 0 1-2.063 4.438c-.875 1.438-2 2.688-3.25 3.813a15.015 15.015 0 0 1-4.625 2.563c-1.813.688-3.75 1-5.75 1-3.25 0-6.188-.875-8.875-2.625.438.063.875.125 1.375.125 2.688 0 5.063-.875 7.188-2.5-1.25 0-2.375-.375-3.375-1.125s-1.688-1.688-2.063-2.875c.438.063.813.125 1.125.125.5 0 1-.063 1.5-.25-1.313-.25-2.438-.938-3.313-1.938a5.673 5.673 0 0 1-1.313-3.688v-.063c.813.438 1.688.688 2.625.688a5.228 5.228 0 0 1-1.875-2c-.5-.875-.688-1.813-.688-2.75 0-1.063.25-2.063.75-2.938 1.438 1.75 3.188 3.188 5.25 4.25s4.313 1.688 6.688 1.813a5.579 5.579 0 0 1 1.5-5.438c1.125-1.125 2.5-1.688 4.125-1.688s3.063.625 4.188 1.813a11.48 11.48 0 0 0 3.688-1.375c-.438 1.375-1.313 2.438-2.563 3.188 1.125-.125 2.188-.438 3.313-.875z"></path></svg>
                        </a>
                        
                        <a v-if="event.artist" class="inline-block h-10 px-2 text-center text-gray-800 no-underline hover:text-red-600 hover:text-underline md:h-auto md:px-2 avatar" data-tippy-content="#facebook" target="_blank" href="<?= $facebook ?>">
                            <svg class="h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M19 6h5V0h-5c-3.86 0-7 3.14-7 7v3H8v6h4v16h6V16h5l1-6h-6V7c0-.542.458-1 1-1z"></path></svg>
                        </a>
                        
                    </div>
                </div>
                <p class="px-6 pt-4 mb-5 font-serif text-base text-gray-800">
                    {{ event.event }}
                </p>
                <div class="flex flex-col px-6 font-serif text-base text-gray-800">
                    <p><span class="font-semibold">Wann:</span> {{ event.date }}</p>
                    <p><span class="font-semibold">Beginn:</span> {{ event.date }} Uhr</p>
                    <p>
                    
                    </p>
                </div>
                <div class="p-6">
                    <a v-bind:href="event.stream" target="_blank">
                    <button class='relative p-2 overflow-visible text-sm font-bold bg-transparent border-2 rounded text-live-orange border-live-orange hover:bg-live-orange hover:text-white hover:border-transparent'>
                        <div class="flex flex-row items-center mr-1">
                            <svg class="w-8 h-8 mr-1 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 374 347.9">
                                <path d="M307.2,183.9c-0.2,36.1-11.4,67.6-33.6,95.3c-4.7,5.9-12.1,6.9-17.7,2.6c-5.8-4.4-6.7-11.9-1.9-18 c13.5-16.9,22.5-35.8,26.2-57.2c5.1-29.2,0.4-56.8-14-82.6c-3.5-6.3-7.9-12.1-12.1-17.9c-4.7-6.6-4.1-13.8,1.7-18.3 c5.8-4.5,13.2-3.2,18.2,3.1C295.8,118.3,306.8,149.5,307.2,183.9"/>
                                <path d="M58.5,184.4c0.2-34.7,11.4-66.1,33.4-93.8c4.8-6,12.3-7.2,18-2.8c5.8,4.5,6.7,11.9,1.8,18 c-12.1,15.2-20.9,32-25.1,50.9c-8.4,37.9-0.6,72.4,22.5,103.6c1.1,1.5,2.4,3,3.4,4.5c3.6,5.1,2.9,11.8-1.6,16.1 c-4.6,4.4-11.6,4.8-16.4,0.6c-2.2-1.9-4.1-4.4-5.9-6.8C68.9,248.2,58.7,218.4,58.5,184.4"/>
                                <path d="M257.4,182.8c-0.4,17.3-3.7,31.6-11.1,44.8c-3.7,6.7-11.2,9-17.6,5.4c-6.1-3.4-8-10.8-4.4-17.4 c11.3-21.2,11.2-42.2-0.7-63.2c-3.6-6.4-1.3-14.2,5.1-17.4c6.6-3.3,13.9-0.4,17.2,6.4c4.3,8.7,8.2,17.5,9.8,27.1 C256.6,174.1,257.1,179.6,257.4,182.8"/>
                                <path d="M108.2,183.5c0.3-14,3.6-28.3,11.1-41.6c3.6-6.5,10.8-8.8,17.1-5.5c6.1,3.2,8.3,10.8,4.8,17.2 c-11.1,20.8-11.1,41.6,0.2,62.3c3.5,6.4,1.4,13.7-4.6,17.1c-6.2,3.4-13.5,1.3-17.2-5.1C112.3,215.2,108.2,199.6,108.2,183.5"/>
                                <path d="M207.7,184.8c0,13.7-11,24.8-24.7,24.9c-13.8,0.1-25.1-11-25.1-24.9c0-13.8,11.2-25,25-24.9 C196.7,160.1,207.7,171.1,207.7,184.8"/>
                            </svg>
                            Livestream starten
                        </div>
                    </button>
                    </a>
                </div>
                
                <div class="flex flex-col px-6 mb-5 font-serif text-base text-gray-800">
                    <p class="italic">Hier kannst Du Deine Künstler direkt supporten, denn durch die abgesagten Konzerte fehlt vielen von ihnen das Einkommen. Nutze die Gelegenheit und schaue auf der Website des Künstlers ob es vielleicht einen Shop mit Merch gibt. Alternativ ist auch eine Spende bspw. über Paypal möglich oder der Kauf eines Social-Tickets. Ein großer Dank an alle Unterstützer!</p>
                </div>
            </div>

            <div class="flex-none p-6 mt-auto overflow-hidden bg-white rounded-t-none rounded-b shadow-lg">
                <div class="flex items-center justify-between">
                    <div class="flex flex-row">
                        <img class="w-8 h-8 mr-1 rounded-full avatar" :data-tippy-content=event.artist :src=event.artistimage :alt=event.artist>
                        <img class="w-8 h-8 mr-4 rounded-full avatar" data-tippy-content="Landstreicher Konzerte" src="https://www.landstreicher-konzerte.de/wp/wp-content/themes/landstreicher2015/images/logo.svg" alt="Avatar of Agency">
                    </div>
                    <button @click="upvoteThisEvent(event.id)" class='relative p-2 overflow-visible text-sm font-bold text-white rounded bg-live-blue focus:outline-none'>
                        <div class="flex flex-row items-center">
                            <svg class="w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 510 510"><path fill="white" d="M255,489.6l-35.7-35.7C86.7,336.6,0,257.55,0,160.65C0,81.6,61.2,20.4,140.25,20.4c43.35,0,86.7,20.4,114.75,53.55    C283.05,40.8,326.4,20.4,369.75,20.4C448.8,20.4,510,81.6,510,160.65c0,96.9-86.7,175.95-219.3,293.25L255,489.6z"/></svg>
                            Support
                        </div>
                        <div class="absolute top-0 right-0 px-3 py-1 -mt-5 -mr-4 rounded-full bg-live-orange">{{ event.upvotes }}</div>
                    </button>
                </div>
            </div>
        </div>
            
          
        </div>
      </div>

			</div>
		</div>
    <Footer />
    </div>
</template>

<script>
    import firebase from "firebase/app";
    import "firebase/auth";
    import "firebase/functions";
    import Header from "@/components/Header";
    import Footer from "@/components/Footer";

    export default {
        data() {
            return {
                events: []
            }
        },
        components: {
            Header,
            Footer
        },
        methods: {
          upvoteThisEvent(id) {
            //console.log(id);
            const upvoteEvent = firebase.functions().httpsCallable('upvoteEvent');
            upvoteEvent({ id })
            .catch(error => {
                console.log(error.message);
            });
          }
        },
        mounted() {
          firebase.firestore().collection('events').where(firebase.firestore.FieldPath.documentId(), "==", this.$route.params.id)
          .get()
          .then(snapshot => {
            let events = [];
              snapshot.forEach(doc => {
                  events.push({...doc.data(), id: doc.id});
              });
            this.events = events;
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
            // const ref = firebase.firestore().collection('events').where("id", "==", "xdK4xh7yBF2z38ca5MQ9" ).orderBy('upvotes', 'desc');
            // ref.onSnapshot(snapshot => {
            // let events = [];
            // snapshot.forEach(doc => {
            //   events.push({...doc.data(), id: doc.id});
            // });
            //   this.events = events;
            // });
        }
    }
</script>

<style lang="scss" scoped>

</style>